import { fromJS } from 'immutable'

export const companyData = fromJS({
    "source": "DEMANDBASE",
    "name": "Wayfair",
    "url": "http://wayfair.com",
    "logo": "https://logo.clearbit.com/wayfair.com",
    "location": "4 Copley Pl, Boston, MA 02116, USA",
    "social": {
        "twitter": {
            "handle": "Wayfair"
        },
        "linkedin": {
            "handle": "company/wayfair"
        }
    },
    "category": {
        "industry": "Internet Software & Services",
        "subIndustry": "Internet Software & Services"
    },
    "metrics": {
        "raised": 0,
        "revenueRange": null,
        "employees": 7030
    },
    "geography": {
        "city": "Boston",
        "state": "Massachusetts",
        "country": "United States",
        "countryCode": "US"
    }
})


// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demodata.js